import { ReactNode } from "react";
import { cx } from "@jugl-web/utils";

export const SignUpFlowContentLayout = ({
  title,
  subtitle,
  description,
  footer,
  hideTitleSection = false,
  titleSectionClassName = "",
}: {
  title: ReactNode;
  subtitle: ReactNode;
  description?: ReactNode;
  footer?: ReactNode;
  hideTitleSection?: boolean;
  titleSectionClassName?: string;
}) => (
  <div className="flex w-full min-w-0 flex-col items-center justify-center px-4 font-secondary sm:px-0 2xl:pt-0 2xl:pr-[64px]">
    {!hideTitleSection && (
      <div
        className={cx(
          "flex w-full max-w-[400px] flex-col items-center justify-center gap-4 pb-6 sm:pb-[32px] 2xl:w-full 2xl:max-w-none 2xl:pb-[64px]",
          titleSectionClassName
        )}
      >
        <div className="text-center text-[28px] leading-9 font-semibold text-dark sm:text-[32px] sm:leading-normal">
          {title}
        </div>
        <div className="text-center text-dark-600">{subtitle}</div>
      </div>
    )}
    <div className="flex w-full justify-center">{description}</div>
    <div className="flex flex-col items-center justify-center">{footer}</div>
  </div>
);
